import {
    HttpResponse,
    ShareModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel, PartyModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse} from '@/libs/core/crud/crud-service';

export class SharesDataService implements CrudService<ShareModel, ShareModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getShareGroupped(query, params);
    }
    
    getAll(query: CrudDataQuery<ShareModel>): Promise<CrudListResponse<ShareModel>> {
        return ApiService.api.getShareBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ShareModel>> {
        return ApiService.api.getShareById(id, params);
    }

    create(item: ShareModel, params?: RequestParams): Promise<CrudResponse<ShareModel>> {
        throw "NotImplemented";
    }

    update(item: ShareModel, params?: RequestParams): Promise<ShareModel> {
        throw "NotImplemented";
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ShareModel> {
        throw "NotImplemented";
    }

    delete(query: CrudDataQuery<ShareModel>): Promise<CrudListResponse<ShareModel>> {
        throw "NotImplemented";
    }

    download(query: CrudDataQuery<ShareModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        return ApiService.api.exportShareBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

}
